_options$p